import { render } from "./onlineServiceModel.vue?vue&type=template&id=d2cd8df4&scoped=true"
import script from "./onlineServiceModel.vue?vue&type=script&lang=js"
export * from "./onlineServiceModel.vue?vue&type=script&lang=js"

import "./onlineServiceModel.vue?vue&type=style&index=0&id=d2cd8df4&scoped=true&lang=scss"

import exportComponent from "D:\\web-master\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2cd8df4"]])

export default __exports__